// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./react-mount"
import "./airwallex_transfer_uploads"

console.log("Application JS loaded");
